export type EchoSide = "center" | "left" | "right";

export interface EchoTap {
  time: number;
  amplitude: number;
  side: EchoSide;
}

export function DelayTaps(
  delayTime: number,
  feedback: number,
  maxTime: number,
  maxTaps = 8,
  floor = 0.05,
): EchoTap[] {
  const taps: EchoTap[] = [];
  for (let idx = 1; idx <= maxTaps; idx++) {
    const time = delayTime * idx;
    if (time > maxTime) break;
    const amplitude = Math.pow(feedback, idx - 1);
    if (amplitude < floor && idx > 1) break;
    taps.push({ time, amplitude, side: "center" });
  }
  return taps;
}

export function PingPongTaps(
  delayLeft: number,
  delayRight: number,
  feedback: number,
  maxTime: number,
  maxTaps = 10,
  floor = 0.05,
): EchoTap[] {
  const taps: EchoTap[] = [];
  let time = 0;
  for (let idx = 0; idx < maxTaps; idx++) {
    const left = idx % 2 === 0;
    time += left ? delayLeft : delayRight;
    if (time > maxTime) break;
    const amplitude = Math.pow(feedback, idx);
    if (amplitude < floor && idx > 0) break;
    taps.push({ time, amplitude, side: left ? "left" : "right" });
  }
  return taps;
}
